import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "page-content" }
const _hoisted_2 = { class: "detail-content" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "detail-info" }
const _hoisted_5 = { class: "detail-info-price" }
const _hoisted_6 = { class: "current-price" }
const _hoisted_7 = { class: "original-price" }
const _hoisted_8 = { class: "detail-info-title" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "pay-btn-wrap" }
const _hoisted_11 = { class: "price" }
const _hoisted_12 = { class: "dialog-content" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "dialog-content-info" }
const _hoisted_15 = { class: "title" }
const _hoisted_16 = { class: "price-wrap" }
const _hoisted_17 = { class: "price" }
const _hoisted_18 = { class: "dialog-footer" }

import CustomTitleBar from "@/components/CustomTitleBar/index.vue";
import { onMounted } from "vue";
import { ref } from "vue";
import { useRoute, useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'detail',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const baseUrl = process.env.VUE_APP_IMG_BASE_URL;
const detail = ref<any>({});
const showPaymentDialog = ref(false);
const quantity = ref(1);

const handleConfirm = () => {
  router.push({
    path: '/Pay',
    query: {
      amount: detail.value.price * quantity.value,
      goodsId: detail.value.id,
      goodsTitle: detail.value.title
    }
  })
}

onMounted(() => {
  if (route.query.item) {
    detail.value = JSON.parse(route.query.item as string);
    if (detail.value.picture) {
      detail.value.images = [detail.value.picture]
    }
    if (detail.value.albumPics) {
      detail.value.images.push(...detail.value.albumPics.split(','));
    }
  }
  console.log(detail.value);
})

const goPay = () => {
  showPaymentDialog.value = true;
}

return (_ctx: any,_cache: any) => {
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_van_stepper = _resolveComponent("van-stepper")!
  const _component_van_dialog = _resolveComponent("van-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomTitleBar, { title: "商品详情" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_carousel, {
          interval: 4000,
          arrow: "always"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.value.images, (item, index) => {
              return (_openBlock(), _createBlock(_component_el_carousel_item, { key: index }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: _unref(baseUrl) + item,
                    alt: "商品图片"
                  }, null, 8, _hoisted_3)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, "¥" + _toDisplayString(detail.value.price), 1),
            _createElementVNode("span", _hoisted_7, "¥" + _toDisplayString(detail.value.originalPrice), 1)
          ]),
          _createElementVNode("div", _hoisted_8, _toDisplayString(detail.value.detailTitle), 1),
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "service-info" }, [
            _createElementVNode("span", null, "支持7天无理由退换"),
            _createElementVNode("span", null, ">")
          ], -1)),
          _createElementVNode("div", {
            class: "detail-info-html",
            innerHTML: detail.value.detailHtml
          }, null, 8, _hoisted_9)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("span", _hoisted_11, "￥" + _toDisplayString(detail.value.price), 1),
        _createElementVNode("div", {
          class: "pay-btn",
          onClick: goPay
        }, "立即购买")
      ])
    ]),
    _createVNode(_component_van_dialog, {
      show: showPaymentDialog.value,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((showPaymentDialog).value = $event)),
      title: "订单确认",
      onConfirm: handleConfirm,
      onCancel: _cache[3] || (_cache[3] = ($event: any) => (showPaymentDialog.value = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("img", {
            src: _unref(baseUrl) + detail.value.picture,
            alt: "商品图片"
          }, null, 8, _hoisted_13),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("span", _hoisted_15, _toDisplayString(detail.value.detailTitle), 1),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("span", _hoisted_17, "￥" + _toDisplayString(detail.value.price * quantity.value), 1),
              _createVNode(_component_van_stepper, {
                modelValue: quantity.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((quantity).value = $event)),
                min: 1
              }, null, 8, ["modelValue"])
            ])
          ])
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", {
            class: "cancel-btn",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (showPaymentDialog.value = false))
          }, "取消"),
          _createElementVNode("div", {
            class: "confirm-btn",
            onClick: handleConfirm
          }, "去支付")
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})